module.exports = __webpack_public_path__ + "img/20191107161854360截图20191107151415676.24c43ee2.jpg";